import { InjectedFormProps, reduxForm } from 'redux-form';

import BrowserFingerprintFields from 'dashboard/forms/FormAddListItem/ListItemTypes/BrowserFingerprintFields';
import CountryFields from 'dashboard/forms/FormAddListItem/ListItemTypes/CountryFields';
import DeviceFingerprintFields from 'dashboard/forms/FormAddListItem/ListItemTypes/DeviceFingerprintFields';
import EmailAddressFields from 'dashboard/forms/FormAddListItem/ListItemTypes/EmailAddressFields';
import FaceFields from 'dashboard/forms/FormAddListItem/ListItemTypes/FaceFields';
import FieldFields from 'dashboard/forms/FormAddListItem/ListItemTypes/FieldFields';
import GeolocationFields from 'dashboard/forms/FormAddListItem/ListItemTypes/GeolocationFields';
import GovernmentIdNumberFields from 'dashboard/forms/FormAddListItem/ListItemTypes/GovernmentIdNumberFields';
import IpAddressFields from 'dashboard/forms/FormAddListItem/ListItemTypes/IpAddressFields';
import NameFields from 'dashboard/forms/FormAddListItem/ListItemTypes/NameFields';
import PhoneNumberFields from 'dashboard/forms/FormAddListItem/ListItemTypes/PhoneNumberFields';
import SelfieBackgroundFields from 'dashboard/forms/FormAddListItem/ListItemTypes/SelfieBackgroundFields';
import StringFields from 'dashboard/forms/FormAddListItem/ListItemTypes/StringFields';
import Form from 'dashboard/layouts/FormLayout/Form';
import { List } from 'dashboard/models/list';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import { ApiModel } from 'lib/interfaces/api';
import { assertNever } from 'lib/utils/types';

export interface FormAddListItemProps {
  listType: List['type'];
  handleCancel: () => void;
}

const FormAddListItem = (
  props: FormAddListItemProps & InjectedFormProps<{}, FormAddListItemProps>,
) => {
  const formFields = ((listType) => {
    switch (listType) {
      case ApiModel.ListGovernmentIdNumber:
        return <GovernmentIdNumberFields {...props} />;
      case ApiModel.ListIpAddress:
        return <IpAddressFields {...props} />;
      case ApiModel.ListName:
        return <NameFields {...props} />;
      case ApiModel.ListPhoneNumber:
        return <PhoneNumberFields {...props} />;
      case ApiModel.ListEmailAddress:
        return <EmailAddressFields {...props} />;
      case ApiModel.ListGeolocation:
        return <GeolocationFields {...props} />;
      case ApiModel.ListBrowserFingerprint:
        return <BrowserFingerprintFields {...props} />;
      case ApiModel.ListDeviceFingerprint:
        return <DeviceFingerprintFields {...props} />;
      case ApiModel.ListString:
        return <StringFields {...props} />;
      case ApiModel.ListFace:
        return <FaceFields {...props} />;
      case ApiModel.ListCountry:
        return <CountryFields {...props} />;
      case ApiModel.ListField:
        return <FieldFields {...props} />;
      case ApiModel.ListSelfieBackground:
        return <SelfieBackgroundFields {...props} />;
      default:
        assertNever(listType);
    }
  })(props.listType);

  return (
    <>
      <Form onSubmit={props.handleSubmit}>
        {formFields}
        <HStack>
          <Button
            variant='basic'
            id='form-add-list-item__cancel'
            disabled={props.submitting}
            onClick={props.handleCancel}
          >
            Cancel
          </Button>
          <Button
            type='submit'
            disabled={props.submitting || props.pristine}
            isPending={props.submitting}
          >
            Add item
          </Button>
        </HStack>
      </Form>
    </>
  );
};

const formName = 'addListItem';

export default reduxForm<{}, FormAddListItemProps>({
  form: formName,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(FormAddListItem);
